import React, { useCallback, useEffect, useState } from 'react';
import {
  KoButton,
  KoForm,
  KoLoader,
  KoModal,
  KoNano,
  KoPagination,
  KoTable,
  KoToast,
  KoTooltips
} from 'packages';

import ProductObject from '../constant';
import KoIcon from '@kwapio/icons';
import styles from '../productCategory.module.scss';
import { OrdersAPI } from '../../../orders.service';
import KoToolBar from 'shared/components/toolbar';
import CategoryForm from './categoryform';
import SubCategoryDetails from './subCategoryDetails';

export default function Category() {

  const [totalCount, setTotalCount] = useState(0);
  const [SubcategoryDetails, setSubCategoryDetails] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [createCategory, setCreateCategory] = useState(false);
  const [form] =KoForm.useForm();
  const [pagination, setPagination] = useState({
    size: 100,
    page: 1
  });

  useEffect(() => {
    getCategory();
  }, []);

  // ⭐ SANITIZE TABLE DATA
  const sanitizeRows = (rows = []) => {
    return rows.map((item) => ({
      ...item,
      image: item?.image?.url ?? "",
      createdAt: item?.createdAt ?? "",
      description: item?.description ?? "",
      name: item?.name ?? ""
    }));
  };

  const getCategory = () => {
    setLoading(true);

    OrdersAPI.getCategory()
      .then((res) => {
        console.log("API Response:", res);

        const rows = Array.isArray(res?.categories)
          ? res.categories
          : [];

        const safeRows = sanitizeRows(rows);

        setCategoryList(safeRows);
        setTotalCount(res?.totalCount ?? safeRows.length);
      })
      .catch((err) => {
        console.error("Category API Error:", err);
        setCategoryList([]);
        setTotalCount(0);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onPagination = (page, pageSize) => {
    setPagination({
      page,
      size: pageSize,
      offset: (page - 1) * pageSize
    });
  };

  const handleFinish = useCallback(
    async(values) => {
      try {
        if (!values) return;
        setLoading(true);
  
        const payload = {
          ...values,
          categoryId: KoNano("CAT")
        };
  
        console.log("Category Values:", payload);
        await OrdersAPI.createCategory(payload);
  
        form.resetFields();
        KoToast.success("Successfully Created");
      } catch (error) {
        console.error(error);
        KoToast.error("Something Went Wrong");
      } finally {
        setLoading(false);
      }
    },
    [form]
  );

  const columnsRight = [
    {
      title: '',
      key: 'actions',
      fixed: 'right',
      width: 40,
      render: (_, row) => (
        <div className={`${styles.table} tableBtn columnsRight`}>

          <KoTooltips title="New Window">
            <KoButton
              size="small"
              iconBtn
              className="btn"
              onClick={() => setSubCategoryDetails(true)}
              icon={<KoIcon width={14} height={14} name="OpenOutlined" />}
            />
          </KoTooltips>

          <KoTooltips title="Edit">
            <KoButton
              size="small"
              iconBtn
              className="btn"
              icon={<KoIcon width={14} height={14} name="EditOutlined" />}
            />
          </KoTooltips>

          <KoTooltips title="Delete">
            <KoButton
              size="small"
              iconBtn
              className="btn"
              icon={<KoIcon width={14} height={14} name="DeleteOutlined" />}
            />
          </KoTooltips>

        </div>
      )
    }
  ];

  const onExtraClick = (open) => {
    setSubCategoryDetails(open);
    
  };

  const createForm =()=>{
    setCreateCategory(true);
  };

  return (
    <div className={`${styles.wrapper} profileSection`}>

      <KoToolBar
        title="Category"
        search={{
          visible: true,
          onChange: () => {},
          placeholder: 'Search by any parameter'
        }}
        filter={{
          visible: false,
          options: [
            { label: 'Sort By Name', key: '0' },
            { label: 'Created At', key: '2' },
            { label: 'Sort By designation', key: '3' }
          ]
        }}
        buttonList={[
          {
            label: 'Create',
            type: 'primary',
            icon: (
              <KoIcon
                color="#FFF"
                name="PlusOutlined"
                width={18}
                height={18}
              />
            ),
            onClick: () =>{createForm(true);}
          }
        ]}
      />

      <KoTable
        extraColumnsRight={columnsRight}
        maxHeight={66}
        data={{
          columns: ProductObject.CAT_COLUMN,
          rows: categoryList
        }}
        onExtraClick={onExtraClick}
      />

      <KoModal
        title="Category"
        centered
        open={createCategory}
        onClose={() => setCreateCategory(false)}
        onOk={() => setCreateCategory(false)}
        width="50vw"
        maskClosable={false}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => { setCreateCategory(false); form.resetFields(); }} />,
          <KoButton key='create' loading={isLoading} type='primary' label={`Create`}
            onClick={() => form.submit()} />
        ]
        }
      >
        {isLoading ? <KoLoader circle={false} /> : <CategoryForm  form={form} handleFinish={handleFinish}  />}
      </KoModal>

      <KoModal
        title="Sub Category Details"
        centered
        open={SubcategoryDetails}
        onClose={() => setSubCategoryDetails(false)}
        onOk={() => setSubCategoryDetails(false)}
        width="90vw"
        maskClosable={false}
      >
        {isLoading ? <KoLoader circle={false} /> : <SubCategoryDetails/>}
      </KoModal>

      <KoPagination
        current={pagination.page}
        total={totalCount}
        pageSize={pagination.size}
        showTotal={(total, range) =>
          `${range[0]}-${range[1]} of ${total} records`
        }
        onChange={onPagination}
      />

    </div>
  );
}
